function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-width:2px;}.a{stroke-linejoin:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15248.928,21585l5.555,5.555-5.555,5.555",
  transform: "translate(-15241.313 -21579.234)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M15233.889,21592.24h12.8",
  transform: "translate(-15233.889 -21580.92)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M15260.4,21578.484v22.588",
  transform: "translate(-15241.983 -21578.484)"
});

var SvgExpandArrow = function SvgExpandArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.416,
    height: 22.588,
    viewBox: "0 0 19.416 22.588",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpandArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expand_arrow.a3249dc3.svg";
export { ForwardRef as ReactComponent };